import React from 'react';
import { Link } from 'react-router';
import { Search } from 'ui';
import { routeConstants } from 'app/routes/route-constants';
import { AdministrationMessagesTranslation } from '../../constants';

import styles from './messages-list-search.scss';

interface MessagesListSearchProps {
  canEdit: boolean;
  query: string;
  updateQuery: (value: string) => void;
  translation: AdministrationMessagesTranslation;
}

export const MessagesListSearch: React.FC<MessagesListSearchProps> = ({
  canEdit, query, updateQuery, translation
}) => {

  const onSearch = () => updateQuery(query);

  return <div className={`row ${styles.searchSection}`}>
    <div className="col-lg-9 col-md-12">
      <Search
        className={`${styles.searchField} input-wrapper`}
        componentId={'messages-search'}
        onChange={updateQuery}
        value={query}
        minLength={1}
        maxLength={255}
        onSearch={onSearch}
        placeholder={translation.search}
        focus={true} />
    </div>
    {!!canEdit && <div className="col-lg-3 col-md-12">
      <div className={styles.searchToolbar}>
        <Link
          id={'messages-list-link-add-new-button'}
          to={routeConstants.administrationMessagesAdd}
          className="btn btn-primary">
          {translation.add_new}
        </Link>
      </div>
    </div>}
  </div>;
};
